// FaroRouteTracker — emits a RUM event on every route change. Needed because
// this app uses HashRouter: hash navigations don't always trigger Faro's
// history-based page tracking, so we capture them explicitly via useLocation.
// Render once inside the router. Renders nothing.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackRoute } from "./faro";

export default function FaroRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackRoute(location.pathname + (location.search || ""));
  }, [location.pathname, location.search]);
  return null;
}
